import { motion } from 'framer-motion'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useMemo } from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { introBottomVariants } from '@/config/const'
import { getHomeMoreIncentive } from '@/services/home'
import { BasicHeaders } from '@/types/common'
import { useAppSelector } from '@/utils/hooks'

import Ornament1 from '~/assets/images/home/shortcut-incentive-ornament-1.png'
import Ornament2 from '~/assets/images/home/shortcut-incentive-ornament-2.png'

const ShortcutIncentive: React.FC = () => {
  const router = useRouter()

  const request: BasicHeaders = useMemo(() => {
    return {
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data: moreIncentive } = useAppSelector(getHomeMoreIncentive.select(request))
  return (
    <motion.div
      className='relative h-fit overflow-hidden rounded-2xl'
      initial='hide'
      whileInView='show'
      viewport={{ once: true }}
      variants={introBottomVariants}
    >
      <div className='absolute inset-0 z-0'>
        <div className='absolute inset-0 z-10 bg-black/50' />
        {moreIncentive?.data.imageFiles && (
          <ImageByWidthDevice
            images={moreIncentive?.data.imageFiles}
            alt='Background Image'
            className='z-0 h-full w-full object-cover object-center'
          />
        )}
      </div>

      <div className='relative z-[11] flex w-full flex-col items-center justify-between gap-y-7.5 px-3 py-4 lg:flex-row lg:p-8'>
        <div className='w-full space-y-4 text-center lg:w-[600px] lg:text-left'>
          <h2 className='text-2xl font-bold leading-8 text-white lg:text-3.5xl lg:leading-normal'>
            {moreIncentive?.data.title}
          </h2>

          <div
            className='description w-full break-words text-sm text-white lg:w-[503px] lg:text-base lg:leading-normal lg:tracking-[-0.176px]'
            dangerouslySetInnerHTML={{ __html: String(moreIncentive?.data.description) }}
          />
        </div>

        <div>
          <Link
            href={moreIncentive?.data?.button.learnMore.url ?? ''}
            className='lg:px-6m flex w-full items-center justify-center gap-2 rounded-[100px] bg-red px-5 py-3 font-work font-bold text-white lg:w-fit lg:px-6 lg:py-4'
          >
            <span>{moreIncentive?.data?.button.learnMore.title}</span>
            <span className='kek-arrow-right text-2xl' />
          </Link>
        </div>
      </div>

      <div className='absolute z-10 xs:-bottom-[418px] xs:-left-[284px]  sml:-bottom-[418px] sml:-left-[284px] md:-bottom-[418px] md:-left-[284px] lg:-bottom-[471px] lg:-left-[334px]'>
        <div className='absolute inset-0 z-10' />

        <img
          src={Ornament1.src}
          alt='Background Image'
          className='z-0 h-full w-[500px] object-cover object-center lg:w-full'
        />
      </div>

      <div className='absolute -top-[25px] right-[41.3px] z-10 hidden lg:block'>
        <div className='absolute inset-0 z-10' />

        <img
          src={Ornament2.src}
          alt='Background Image'
          className='z-0 hidden h-[158px] w-[100.703px] lg:block'
        />
      </div>
    </motion.div>
  )
}

export default ShortcutIncentive
